import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-18652 Переход на ручки V4 для инициализации Р7
 */
export const R7_API_V4 = getFeature('r7-api-v4') || false;
